import { AfterViewInit, Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[genReadMore]'
})
export class ReadMoreDirective implements  AfterViewInit {

  @Input() maxHeight: number;
  private showAll: boolean = false;

  constructor(private element: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    if (this.element.nativeElement.offsetHeight > this.maxHeight) {
      this.element.nativeElement.setAttribute('style', `max-height:${this.maxHeight}px`);

      const button = this.renderer.createElement('a');
      button.setAttribute('href', ' javascript:void(0)');
      this.renderer.appendChild(button, this.renderer.createText('Read more'));
      this.renderer.listen(button, 'click', (evt) => {
        this.showAll = !this.showAll;
        if (this.showAll) {
          this.element.nativeElement.setAttribute('style', `max-height:100%`);
          button.innerText = 'Read Less';
        }
        else {
          this.element.nativeElement.setAttribute('style', `max-height:${this.maxHeight}px`);
          button.innerText = 'Read More';
        }
      });

      this.renderer.appendChild(this.element.nativeElement.parentElement, button);
    }
  }

}
